/*! JointJS+ v4.0.1 - HTML5 Diagramming Framework

Copyright (c) 2024 client IO

 2024-04-11 


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at https://www.jointjs.com/license
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/


import {
    AVALIATION_ICON,
    CREATE_TICKET_ICON,
    ENTITY_ICON,
    FLOW_ICON,
    MESSAGE_ICON,
    RESPONSE_PARAM_ICON,
    TALK_ATTENDANT_ICON,
    USER_INPUT_ICON
} from '../../theme';

export const stencilConfig = {
    shapes: [
        {
            name: 'FlowchartStart',
            attrs: {
                label: { text: 'Início' },
            }
        }, 
        {
            name: 'FlowchartEnd',
            attrs: {
                label: { text: 'Fim' },
            }
        }, 
        {
            name: 'Message',
            attrs: {
                label: { text: 'Resposta de opções' },
                icon: { xlinkHref: USER_INPUT_ICON }
            }
        }, {
            name: 'Service',
            attrs: {
                label: { text: 'Resposta serviço' },
                icon: { xlinkHref: ENTITY_ICON }
            }
        }, 
        {
            name: 'ResponseParam',
            attrs: {
                label: { text: 'Resposta parâmetro' },
                icon: { xlinkHref: RESPONSE_PARAM_ICON }
            }
        }, 
        {
            name: 'ResponseOrientation',
            attrs: {
                label: { text: 'Resposta orientação' },
                icon: { xlinkHref: MESSAGE_ICON }
            }
        },
        {
            name: 'TalkAttendant',
            attrs: {
                label: { text: 'Falar com atendente' },
                icon: { xlinkHref: TALK_ATTENDANT_ICON }
            }
        },
        {
            name: 'Flow',
            attrs: {
                label: { text: 'Fluxos' },
                icon: { xlinkHref: FLOW_ICON }
            }
        },
        {
            name: 'CreateTicket',
            attrs: {
                label: { text: 'Criar ticket' },
                icon: { xlinkHref: CREATE_TICKET_ICON }
            }
        },
        {
            name: 'Avaliation',
            attrs: {
                label: { text: 'Avaliação' },
                icon: { xlinkHref: AVALIATION_ICON }
            }
        },
    ]
};